import {
  Package,
  ChevronRight,
  ShoppingBag,
  Calendar,
  CreditCard,
  Truck,
  CheckCircle2,
  Clock,
  XCircle,
  AlertCircle,
  Info,
  RotateCcw,
} from "lucide-react";

export const getStatusIcon = (iconName: string) => {
  const iconProps = { className: "w-4 h-4" };
  switch (iconName) {
    case 'truck': return <Truck {...iconProps} />;
    case 'check-circle': return <CheckCircle2 {...iconProps} />;
    case 'clock': return <Clock {...iconProps} />;
    case 'x-circle': return <XCircle {...iconProps} />;
    case 'alert-circle': return <AlertCircle {...iconProps} />;
    case 'info': return <Info {...iconProps} />;
    case 'calendar': return <Calendar {...iconProps} />;
    case 'rotate-ccw': return <RotateCcw {...iconProps} />;
    case 'package': return <Package {...iconProps} />;
    default: return null;
  }
};